import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M1.413 9.018c.495 3.187 3.268 5.647 6.587 5.647 3.667 0 6.667-3 6.667-6.666 0-3.665-3-6.665-6.667-6.665a6.665 6.665 0 0 0-5.333 2.667V1.334H1.336l-.003 4.667H6V4.667H3.867c.933-1.2 2.468-2 4.135-2 2.931 0 5.332 2.4 5.332 5.332s-2.4 5.334-5.334 5.334c-2.585 0-4.753-1.864-5.232-4.315H1.414Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M7.335 4.667v3.534l2.133 2.865 1.067-.798-1.867-2.467V4.667"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }